module.exports = __webpack_public_path__ + "img/overLookingCar.6b44116b.png";